import { z } from 'zod';
import { FILTER_ATTRIBUTES_BY_CATEGORY } from '#/products/search';

const schemaCheckbox = z.object({
  values: z
    .string()
    .or(z.array(z.string()))
    .transform((v) => (Array.isArray(v) ? v : [v])),
});

// Dynamically build the schema from FILTER_ATTRIBUTES_BY_CATEGORY
const allAttributeSlugs = Array.from(
  new Set(
    Object.values(FILTER_ATTRIBUTES_BY_CATEGORY).flatMap(categoryAttrs =>
      Object.keys(categoryAttrs)
    )
  )
);

const schemaAttributes = z.object(
  Object.fromEntries(
    allAttributeSlugs.map(slug => [slug, schemaCheckbox.optional()])
  )
);

export const schemaSearch = z.object({
  search: z.string().optional(),
  sort: z.enum(['name', 'price', 'date', 'rating', 'ranking']).optional(),
  direction: z.enum(['asc', 'desc']).optional(),

  price: z
    .object({
      gte: z.preprocess((v) => {
        return v == '' ? undefined : v;
      }, z.coerce.number().min(0).optional()),
      lte: z.preprocess((v) => {
        return v == '' ? undefined : v;
      }, z.coerce.number().min(0).optional()),
    })
    .optional(),
  after: z.string().optional(),
  categories: z.array(z.string()).optional(),
  collections: z.array(z.string()).optional(),

  attributes: schemaAttributes.optional(),
});
